import {useQuery} from '@tanstack/react-query';
import {useParams} from 'react-router-dom';
import React, {useContext, useState} from 'react';
import {resourceTypeFormatting, TEVService} from '../tevapi/io';
import {ICollectionOverview} from '../tevapi/interfaces';
import {Col, Modal, Row, Space, Spin, Typography} from 'antd';
import {DataTable} from './datatable';
import FileViewer, {FileContext} from './file-viewer';
import {ContinueVettingList, StartVetting} from './vetting/vetting-select';
import {RESOURCETOHELPLOOKUP} from './help/item-data-docs';


export const Collection: React.FC = () => {
  const {pk} = useParams();
  const [fileUrl, setFileUrl] = useContext(FileContext)
  const [selection, setSelection] = useState<Set<number>>(new Set());
  const [selectionConfig, setSelectionConfig] = useState({
    selectedRowKeys: selection,
    onChange: console.log,
    onSelectAll: console.log,
    onSelectInvert: console.log,
    onSelectNone: console.log,
    onSelectMultiple: console.log,
    preserveSelectedRowKeys: true,
    selections: true,
    fixed: false,
  });

  if (pk == undefined) {
    return <Typography.Text code>Error, collection primary key is not defined!</Typography.Text>;
  }

  const collectionQuery = useQuery({
    queryKey: ["collections", pk],
    queryFn: async (): Promise<ICollectionOverview> => {
      const response = await TEVService.get(`/collections/${pk}/`);

      return response.data;
    }
  });

  if (collectionQuery.isLoading || !collectionQuery.data) {
    return (
      <Row>
        <Col>
          <Spin />
        </Col>
      </Row>
    );
  }

  const collection = collectionQuery.data;

  return (
    <>
      <Row>
        <Col span={12}>
          <Typography.Title>
            {collection.name}
          </Typography.Title>
          <Space>
            <Typography.Title level={3}>
              {collection.columns.name}: {resourceTypeFormatting(collection.columns.item_class)}
            </Typography.Title>
            {RESOURCETOHELPLOOKUP[collection.columns.item_class]}
          </Space>
        </Col>
        <Col span={12}>
          <ContinueVettingList pk={pk} />
        </Col>
      </Row>
      <Row>
        <Col>
          <Modal
            open={fileUrl}
            onOk={() => setFileUrl(null)}
            onClose={() => setFileUrl(null)}
            onCancel={() => setFileUrl(null)}

            width="75%"
            destroyOnClose={true}
          >
            <FileViewer />
          </Modal>
          <DataTable
            collection={collection}
            rowSelection={selectionConfig}
          />
        </Col>
      </Row>
    </>
  );

};
